import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/header-logo.png")